import React from 'react';
import '../../../component-styles/ManualCreditModal.css';
import API_BASE from '../../../utils/api.js';
import notify from '../../../utils/notify';

export default function RefundRetainerModal({ retainer, projectId, onClose, onRefunded }) {

  const available = Number(retainer.availableBalance || 0);

  const confirmRefund = async () => {
    if (available <= 0) return;

    const res = await fetch(
      `${API_BASE}/api/retainers/${projectId}/${retainer.retainerId}/refund`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          userid: localStorage.getItem('userId'),
        },
        body: JSON.stringify({
          amount: available, // refund remaining available balance
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      notify(data.error || 'Refund failed');
      return;
    }

    onRefunded(data);
    onClose();
  };

  return (
    <div className="manualcredit-overlay">
      <div className="manualcredit-card">
        <div className="manualcredit-head">
          <h3>Refund Retainer</h3>
          <button className="manualcredit-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="manualcredit-body">
          {available > 0 ? (
            <>
              <p>
                You are about to refund <strong>{retainer.retainerNumber}</strong> for
                <strong> ${available.toFixed(2)}</strong>.
              </p>

              <p style={{ marginTop: 8 }}>
                <em>
                  This refund must be processed manually (check, card terminal, bank transfer,
                  etc.). InteriorFolio will only update the retainer balance.
                </em>
              </p>
            </>
          ) : (
            <p>
              <strong>No refundable balance remains for this retainer.</strong>
            </p>
          )}
        </div>

        <div className="manualcredit-footer">
          <button className="manualcredit-btn-secondary" onClick={onClose}>
            Cancel
          </button>

          <button
            className="manualcredit-btn-primary"
            onClick={confirmRefund}
            disabled={available <= 0}
          >
            Confirm Refund
          </button>
        </div>
      </div>
    </div>
  );
}
